import { hideElement } from "../helpers";
import { init as initProductCard } from "../snippets/product-card";

const SECTION_NAME = "main-search-products";

/** @param {HTMLElement} baseElement */
export function init(baseElement) {
  if (window.IntersectionObserver) {
    setupInfiniteScroll(baseElement);
  }
  setupProductCards(baseElement);
}

/** @param {HTMLElement} baseElement */
function setupInfiniteScroll(baseElement) {
  const nextButton = baseElement.querySelector(".main-search-next-button");
  const pagination = baseElement.querySelector(".main-search-pagination");
  const loading = baseElement.querySelector(".main-search-loading");

  // When infinite scroll is active, pagination
  // buttons should stay hidden
  if (pagination instanceof HTMLElement) {
    hideElement(pagination);
  }
  if (loading instanceof HTMLElement) {
    loading.style.opacity = "1.0";
  } else {
    // Loading element is integral to the infinite scroll
    // because it will be used as intersection target
    return;
  }

  // Grap url of next page from the button href
  let nextPageUrl;
  if (nextButton instanceof HTMLAnchorElement) {
    nextPageUrl = nextButton.href;
  }

  // If there is no next page link, there is no work to be done.
  if (!nextPageUrl) {
    hideElement(loading);
    return;
  }

  const observer = new IntersectionObserver(function(entries, observer) {
    const entry = entries[0];
    if (entry.isIntersecting) {
      // Unsubscribe right away
      observer.unobserve(entry.target);
      // do something
      renderNextSection();
    }
  });

  observer.observe(loading);

  async function renderNextSection() {
    // Fetch main-search section from next page
    let nextPageSectionHtml;
    try {
      const response = await fetch(nextPageUrl + "&sections=" + SECTION_NAME);
      const data = await response.json();
      nextPageSectionHtml = data[SECTION_NAME];
    } catch (err) {
      console.error(err);
    }
    // If server returns nothing, leave.
    if (!nextPageSectionHtml) return;

    if (loading instanceof HTMLElement) {
      hideElement(loading);
    }

    // Insert section HTML after the current section
    baseElement.insertAdjacentHTML("afterend", nextPageSectionHtml);
    const nextPageSection = baseElement.nextElementSibling;

    if (nextPageSection instanceof HTMLElement) {
      // Setup infinite scroll on the next section
      setupInfiniteScroll(nextPageSection);
      // Setup product card scripts on the next section
      setupProductCards(nextPageSection);
    }
  }
}

/** @param {HTMLElement} baseElement */
function setupProductCards(baseElement) {
  const cards = baseElement.querySelectorAll(".product-card");
  if (cards) {
    cards.forEach(initProductCard);
  }
}
